import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./4th.css";

import { FaBookOpen } from "react-icons/fa";
import { MdTranslate } from "react-icons/md";
import { TbMath } from "react-icons/tb";
import { GiTreeBranch } from "react-icons/gi";

const content = {
  en: {
    heading: "📘 4th Standard Subjects",
    subjects: [
      {
        name: "Marathi",
        icon: <MdTranslate />,
        backendSubject: "Marathi",
      },
      {
        name: "English",
        icon: <FaBookOpen />,
        backendSubject: "English",
      },
      {
        name: "Mathematics",
        icon: <TbMath />,
        backendSubject: "Maths",
      },
      {
        name: "Environmental Studies",
        icon: <GiTreeBranch />,
        backendSubject: "Evs",
      },
    ],
  },

  mr: {
    heading: "📘 इयत्ता ४ थी विषय",
    subjects: [
      {
        name: "मराठी",
        icon: <MdTranslate />,
        backendSubject: "Marathi",
      },
      {
        name: "इंग्रजी",
        icon: <FaBookOpen />,
        backendSubject: "English",
      },
      {
        name: "गणित",
        icon: <TbMath />,
        backendSubject: "Maths",
      },
      {
        name: "परिसर अभ्यास",
        icon: <GiTreeBranch />,
        backendSubject: "Evs",
      },
    ],
  },
};

const Fourth = ({ language = "mr" }) => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const selected = content[language];

  const navigate = useNavigate();
  
    const handleClick = (backendSubject) => {
  
      navigate("/quiz-details", {
  
        state: {
  
          standard: 4,
  
          subject: backendSubject
  
        }
  
      });
    }

  return (
    <section className="fourth-page">

      <h2 className="fourth-heading">{selected.heading}</h2>

      {/* BLACKBOARD */}
      <div className="subjects-board">

        <div className="fourth-grid">

          {selected.subjects.map((subject, index) => (
            <div
              key={index}
              className={`fourth-tile tile-${index}`}
              onClick={() => handleClick(subject.backendSubject)}
            >
              <div className="tile-icon">{subject.icon}</div>
              <h3>{subject.name}</h3>
            </div>
          ))}

        </div>

      </div>

    </section>
  );
};

export default Fourth;